import type { CityConfig } from "../city-template/types";

export const columbusInConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Columbus",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "columbus-in",
  route: "/columbus-in",
  title: "Emergency Passport Columbus, IN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Columbus, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for Columbus, Edinburgh, Hope, Seymour, and all Bartholomew County residents. A+ BBB rated courier service.",
  h1: "Emergency & Expedited Passport Services in Columbus, IN",
  heroSubtitle: "Columbus travelers — from Cummins engineers heading overseas to Bartholomew County families to architecture enthusiasts visiting the world-renowned modern buildings — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated registered courier with direct access to the Chicago Passport Agency, just 45 minutes north via I-65.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Columbus%20Indiana%20with%20iconic%20modern%20architecture%20including%20the%20First%20Christian%20Church%20designed%20by%20Eliel%20Saarinen%2C%20the%20Bartholomew%20County%20Courthouse%20and%20downtown%20streetscape%2C%20the%20Robert%20N%20Stewart%20Bridge%20over%20the%20Flatrock%20River%2C%20contemporary%20design%20landmarks%2C%20golden%20afternoon%20light%20on%20midcentury%20modern%20buildings%2C%20professional%20city%20photography%20with%20warm%20tones%2C%20sophisticated%20small%20city%20atmosphere%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20photography%20with%20architectural%20detail&width=1800&height=700&seq=columbus-in-hero-001&orientation=landscape",
  heroImageAlt: "Columbus Indiana modern architecture and Bartholomew County Courthouse with Flatrock River",
  geoPosition: "39.2014;-85.9214",
  geoPlacename: "Columbus, Indiana",
  lastModified: "2026-06-08",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604",
    distance: "Approximately 3 hours northwest via I-65",
  },
  nearbyCitiesZips: [
    { name: "Columbus", zips: "47201, 47202, 47203" },
    { name: "Edinburgh", zips: "46124" },
    { name: "Hope", zips: "47246" },
    { name: "Seymour", zips: "47274" },
    { name: "Franklin", zips: "46131" },
    { name: "Nashville", zips: "47448" },
    { name: "North Vernon", zips: "47265" },
    { name: "Shelbyville", zips: "46176" },
    { name: "Greensburg", zips: "47240" },
    { name: "Greenwood", zips: "46142, 46143" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Registered courier to Chicago Passport Agency — only 45 minutes from Columbus via I-65" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Bartholomew County" },
    { icon: "ri-building-line", title: "Cummins & Corporate Hub", desc: "Serving Cummins engineers, business travelers, and Bartholomew County families" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels from any UPS or FedEx in Columbus or Edinburgh" },
  ],
  internalLinks: [
    { name: "Expedited passport in Indianapolis, IN", route: "/indianapolis" },
    { name: "Emergency passport help in Carmel, IN", route: "/carmel" },
    { name: "Passport services in Evansville, IN", route: "/evansville" },
    { name: "Indiana passport services overview", route: "/indiana" },
  ],
  fpcOfficeAddress: "230 S Dearborn St Suite 380, Chicago IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Columbus, Indiana via secure registered courier to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604). Approximately 3 hours via I-65. We handle the drive so Columbus residents and Cummins business travelers never need to worry about Chicago traffic.",
  fpcOfficeDistance: "Serving Columbus, Edinburgh, Hope, Seymour, Franklin, Nashville, North Vernon, Shelbyville, Greensburg, Greenwood, and all of Bartholomew County and south-central Indiana",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Columbus and Bartholomew County. From the Cummins corporate campus and the architectural landmarks of downtown Columbus to Edinburgh, Hope, and Seymour — we serve all of south-central Indiana.",
  nearbyCitiesIntro: "We serve Columbus and all nearby communities including Edinburgh, Hope, Seymour, Franklin, Nashville, North Vernon, Shelbyville, Greensburg, and Greenwood. We also serve all of Bartholomew County, Jackson County, and the surrounding south-central Indiana region.",
  howItWorksIntro: "Most Columbus travelers — especially Cummins business travelers and Bartholomew County families — complete everything online and ship documents via overnight courier. Because the Chicago Passport Agency is less than an hour up I-65, our courier turnaround is fast and reliable.",
  mistakesIntro: "Columbus is a global manufacturing and engineering hub with significant international business travel. Here are the most common passport mistakes we see from Bartholomew County travelers.",
  testimonialsIntro: "Columbus travelers — from Cummins professionals to Bartholomew County families to architecture tourists — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Columbus, IN? Here are the most common ones we hear from Bartholomew County travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  dmvWebsite: "https://www.in.gov/bmv",
  dmvLabel: "Indiana BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — only 45 minutes via I-65", "No drive required — ship from Columbus", "Perfect for Cummins business travel and family vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — only 45 minutes via I-65", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Chicago Passport Agency (~45 minutes each way)", "Limited appointments available"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Columbus travelers with immediate departure needs — as fast as 24 hours. Essential for Cummins business travelers and Bartholomew County residents with urgent international plans.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency — courier handles the 45-min drive", "Cummins corporate travel and family travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Columbus adults with a passport issued within the last 15 years. Skip the post office entirely and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Bartholomew County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Columbus residents and families — including new citizens and young adults heading abroad for the first time.",
      bullets: ["Acceptance facility scheduling in Columbus or Franklin", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Columbus residents who lost their passport before international travel or business trips abroad.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Columbus and Bartholomew County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Columbus and Bartholomew County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Columbus IN", description: "Urgent passport processing for Columbus Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Columbus IN", description: "Fast passport renewal for Columbus Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport Columbus IN", description: "New passport application services for Columbus Indiana residents applying for their first passport." },
    { name: "Child Passport Columbus IN", description: "Minor passport services for Columbus Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Robert C.",
      location: "Columbus, IN — Near Cummins HQ",
      rating: 5,
      text: "Emergency business trip to our plant in Brazil — found out my passport was expired on Monday, flight was Saturday. Fast Passport Center got my renewal done in 3 days. The proximity to the Indianapolis agency is fantastic. Saved the trip.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Lisa M.",
      location: "Columbus, IN — Tipton Lakes",
      rating: 5,
      text: "Family vacation to Italy — two renewals and one new passport for our daughter. Fast Passport Center had everything done in 5 days. We shipped from the UPS Store on National Road and never had to worry.",
      service: "Family Passport Bundle",
    },
    {
      name: "Mark D.",
      location: "Seymour, IN",
      rating: 5,
      text: "Mission trip to Guatemala with our church group. Needed a first-time passport with only 2 weeks notice. Fast Passport Center handled everything — had my passport in 4 days. Truly exceptional service.",
      service: "New Passport (First-Time)",
    },
    {
      name: "Jennifer W.",
      location: "Columbus, IN — Downtown",
      rating: 5,
      text: "Lost my passport during a move and had a trip to London in 10 days. Fast Passport Center replaced it in 48 hours. I was panicking but they made it so easy. Shipping from the Columbus FedEx was seamless.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "columbus-in-1",
      name: "Columbus Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "450 Jackson St",
      city: "Columbus",
      state: "IN",
      zip: "47201",
      phone: "(812) 376-4424",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Columbus, near the Bartholomew County Courthouse",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Columbus acceptance facility. Appointments required — book 1–2 weeks in advance. Convenient downtown location near the architectural landmarks district.",
      icon: "ri-mail-line",
    },
    {
      id: "columbus-in-2",
      name: "Bartholomew County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "234 Washington St",
      city: "Columbus",
      state: "IN",
      zip: "47201",
      phone: "(812) 379-1600",
      hours: "Mon–Fri: 8:00 AM – 4:00 PM",
      distance: "Downtown Columbus, Bartholomew County Courthouse",
      website: "https://www.bartholomew.in.gov/",
      websiteLabel: "Bartholomew County",
      notes: "County clerk passport acceptance at the Bartholomew County Courthouse. Extended morning hours. Good for county residents needing full-service passport processing.",
      icon: "ri-government-line",
    },
    {
      id: "columbus-in-3",
      name: "Franklin Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 E Jefferson St",
      city: "Franklin",
      state: "IN",
      zip: "46131",
      phone: "(317) 736-7711",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 25 miles north of Columbus, in Franklin",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Northern acceptance facility near Johnson County. Good alternative when Columbus appointments are full. Convenient I-65 access.",
      icon: "ri-mail-line",
    },
    {
      id: "columbus-in-4",
      name: "Seymour Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "111 N Chestnut St",
      city: "Seymour",
      state: "IN",
      zip: "47274",
      phone: "(812) 522-2846",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 20 miles south of Columbus, in Seymour",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Southern acceptance facility for Jackson County residents. Convenient for Seymour and North Vernon area travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "columbus-in-5",
      name: "Shelbyville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 E Washington St",
      city: "Shelbyville",
      state: "IN",
      zip: "46176",
      phone: "(317) 398-5614",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Approximately 25 miles northeast of Columbus, in Shelbyville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Northeast acceptance facility for Shelby County. Good alternative for residents in the northeastern part of the Columbus service area.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 45-minute drive to Indianapolis via I-65", fpc: "No — ship from Columbus, courier handles it" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Cummins Business Travel", agency: "No special corporate support", fpc: "Experienced with corporate travel deadlines and last-minute business trips" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Assuming 6 Weeks Is Plenty of Time",
      description: "Routine passport processing takes 8–11 weeks — not 4–6 as many Columbus travelers assume. If your business trip or family vacation is within 10 weeks, use expedited service.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Columbus photo services sometimes produce photos that fail passport standards. Photos must be exactly 2x2 inches on a white background — no exceptions, no filters, no glasses.",
    },
    {
      icon: "ri-file-list-line",
      title: "Missing International Travel Signatures",
      description: "Cummins business travelers who travel frequently sometimes forget that passport renewals require a new signature and photo — even if you have a valid passport.",
    },
    {
      icon: "ri-calendar-line",
      title: "Not Accounting for Corporate Travel Peaks",
      description: "Cummins and other Bartholomew County employers have peak international travel cycles tied to trade shows, manufacturing audits, and global meetings. Plan your passport renewal during slower corporate periods when possible.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking Visa Requirements",
      description: "Many Cummins business destinations — Brazil, China, India — require visas in addition to a valid passport. Start the visa process as soon as your passport is ready. Some visas can take 2–4 weeks to process.",
    },
    {
      icon: "ri-passport-line",
      title: "Letting Passport Pages Run Out",
      description: "Frequent business travelers from Columbus sometimes run out of blank visa pages. The U.S. no longer adds pages to existing passports — you must renew. If you travel often, request the 52-page passport book.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Columbus or Bartholomew County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx on National Road or Jonathan Moore Pike." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Bartholomew County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier delivers to the Chicago Passport Agency — just 45 minutes up I-65." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Columbus address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Columbus, IN?", a: "Fast Passport Center offers emergency passport processing in Columbus, Indiana in as little as 24–48 hours. Because the Chicago Passport Agency is only 45 minutes away (230 S Dearborn St Suite 380, Chicago IL 60604), our registered couriers can hand-deliver your documents quickly via the I-65 corridor." },
    { q: "Does Columbus have its own passport agency?", a: "No — Columbus does not have its own passport agency. The nearest is the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604), about 45 miles north — a 45-minute drive via I-65. Fast Passport Center's courier service means Columbus residents never need to make the drive themselves." },
    { q: "Can Fast Passport Center help Cummins employees with business travel?", a: "Absolutely. Fast Passport Center serves all Cummins employees and Bartholomew County business travelers. We understand corporate travel deadlines — plant visits, supplier audits, global meetings — and can coordinate expedited services to match your specific travel schedule." },
    { q: "What airport do Columbus travelers use for international flights?", a: "Indianapolis International Airport (IND) is the primary airport for Columbus and Bartholomew County. IND is approximately 55 miles north via I-65 (about a 1-hour drive) and offers direct flights to Toronto, Cancun, and Paris (seasonal) plus connecting service worldwide." },
    { q: "How much does an expedited passport cost in Columbus, IN?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Columbus?", a: "Walgreens (2110 W Jonathan Moore Pike), CVS (3550 Central Ave), and the UPS Store (2330 25th St) offer passport photo services in Columbus. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Seymour, Edinburgh, and other nearby towns?", a: "Yes. Fast Passport Center serves all of Bartholomew County and surrounding areas including Edinburgh, Hope, Seymour, Franklin, Nashville, North Vernon, Shelbyville, and Greensburg. Our courier service works the same for all south-central Indiana residents." },
    { q: "Can you help with visas for my business trip after I get my passport?", a: "While we specialize in expedited U.S. passport services, we recommend starting your visa process as soon as your passport is ready. Many countries require visas processed through their consulates — Brazil, China, India, and Russia can take 2–4 weeks for business visas." },
  ],
  photoLocations: [
    { name: "Walgreens — Columbus", address: "2110 W Jonathan Moore Pike, Columbus, IN 47201", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/photo" },
    { name: "CVS — Columbus", address: "3550 Central Ave, Columbus, IN 47203", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/photo" },
    { name: "UPS Store — Columbus", address: "2330 25th St, Columbus, IN 47201", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart — Columbus", address: "2304 25th St, Columbus, IN 47201", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/photo" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — Columbus", address: "3520 Two Mile House Rd, Columbus, IN 47201", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Indiana Bureau of Motor Vehicles for driver's licenses and REAL ID. Online reservations strongly recommended. Convenient location off Jonathan Moore Pike.", featured: true },
    { name: "Indiana BMV — Franklin", address: "351 E Jefferson St, Franklin, IN 46131", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Alternative BMV in Franklin for northern Bartholomew County and Johnson County residents. REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "IND",
      name: "Indianapolis International Airport",
      distance: "55 miles north of Columbus via I-65 — approximately 1 hour",
      address: "7800 Col. H. Weir Cook Memorial Dr, Indianapolis, IN 46241",
      note: "Primary airport for Columbus and Bartholomew County. Direct flights to Toronto, Cancun, and Paris (seasonal). Connecting service worldwide through major hubs. The main hub for Cummins international business travelers.",
      flightUrl: "https://www.ind.com/",
      flightLabel: "IND Flight Info",
      featured: true,
    },
    {
      code: "SDF",
      name: "Louisville Muhammad Ali International Airport",
      distance: "80 miles south of Columbus via I-65 — approximately 1.5 hours",
      address: "600 Terminal Dr, Louisville, KY 40209",
      note: "Alternative airport for Columbus travelers. UPS Worldport hub with domestic and limited international connections. Good option when IND flights are limited.",
      flightUrl: "https://www.flylouisville.com/",
      flightLabel: "SDF Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { label: "Bartholomew County: Birth & Death Certificates", url: "https://www.in.gov/health/vital-records/", icon: "ri-file-text-line", description: "Indiana Department of Health Vital Records — order birth and death certificates for Bartholomew County and all Indiana counties" },
    { label: "Bartholomew County Clerk: Marriage Licenses", url: "https://www.bartholomew.in.gov/", icon: "ri-heart-line", description: "Bartholomew County Clerk — marriage license records for Columbus and Bartholomew County" },
    { label: "Bartholomew County: Divorce Decrees", url: "https://www.bartholomew.in.gov/", icon: "ri-file-list-3-line", description: "Bartholomew County Clerk of Courts — divorce decree records for Columbus and Bartholomew County" },
    { label: "VitalChek Nationwide Service", url: "https://www.vitalchek.com/", icon: "ri-global-line", description: "Order Indiana vital records online through VitalChek for delivery to your Columbus address" },
  ],
};